(() => {
  const root = document.documentElement;
  let scheduled = false;
  const visible = (element) => {
    if (!element || !element.getClientRects().length) return false;
    const style = getComputedStyle(element);
    return style.display !== 'none' && style.visibility !== 'hidden' && Number(style.opacity) !== 0;
  };
  const update = () => {
    scheduled = false;
    const consentVisible = visible(document.querySelector('#pandectes-banner'));
    const modalVisible = [...document.querySelectorAll('[role="dialog"][aria-modal="true"], dialog[open], .privy-popup-container')].some(visible);
    root.classList.toggle('seo-consent-visible', consentVisible);
    root.classList.toggle('seo-modal-visible', modalVisible);
  };
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(update);
  };
  new MutationObserver((changes) => {
    if (changes.some(change => change.target !== root)) schedule();
  }).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['class', 'style', 'hidden', 'open', 'aria-hidden', 'aria-modal'] });
  window.addEventListener('resize', schedule, { passive: true });
  update();
})();
